
function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th'; // covers 11th to 20th
    switch (day % 10) {
        case 1      : return 'st';
        case 2      : return 'nd';
        case 3      : return 'rd';
             default: return 'th';
    }
}

const DateFormatter = (dateString, format) => {
    const date          = new Date(dateString);
    const day           = date.getDate();
    const monthLong     = date.toLocaleString('default', { month: 'long' });
    const monthShort    = date.toLocaleString('default', { month: 'short' });
    const year          = date.getFullYear();
    const ordinalSuffix = getOrdinalSuffix(day);

    switch (format) {
        case 'YYYY': 
            return `${year}`;
        case 'MM DD, YYYY': 
            return `${monthLong} ${day}, ${year}`;
        case 'MM DDth, YYYY': 
            return `${monthLong} ${day}${ordinalSuffix}, ${year}`;
        case 'Day of Month, YYYY': 
            return `${day}${ordinalSuffix} day of ${monthLong}, ${year}`;
        default: 
            return `${monthLong} ${day}, ${year}`;
    }
}
 
export default DateFormatter;